import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeStatusIcon } from "../Icons/IssueTypeStatusIcon"

export interface IssueTypeStatusGroupProps extends MenuGroupProps {
	issueTypeStatuses: Stored<IssueTypeStatus>[]
	onSelectIssueTypeStatus: (issueTypeStatus: Stored<IssueTypeStatus>) => void
}

export const IssueTypeStatusGroup = memo<IssueTypeStatusGroupProps>((props) => {
	const { ref, issueTypeStatuses, onSelectIssueTypeStatus, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{issueTypeStatuses.map((issueTypeStatus) => (
				<Menu.Item key={issueTypeStatus.uuid} onSelect={() => onSelectIssueTypeStatus(issueTypeStatus)}>
					<IssueTypeStatusIcon issueTypeStatusId={issueTypeStatus.uuid} />
					<Text className="truncate">{issueTypeStatus.name}</Text>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
IssueTypeStatusGroup.displayName = "IssueTypeStatusGroup"
